import { delay } from 'lodash';
import { useEffect, useState } from 'react';

import UImage from '../../../../components/UImage';
import { Diary } from '../../../../type/recipe';
import { useRouterQuery } from '../../../../utils/hook/useRouterQuery';
import LoadingPage from '../../../LoadingPage';
import { DiaryShortsModalQuery } from '../components/DiaryShortsModal';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsPhoto = ({
  diary,
  photo,
  index,
}: {
  diary: Diary;
  photo: string;
  index: number;
}) => {
  const [imageLoading, setImageLoading] = useState(
    typeof window !== 'undefined', // 서버사이드 렌더링 고려
  );
  const { getDiaryPhotoId } = useDiaryShortsContext();
  const { query } = useRouterQuery<DiaryShortsModalQuery>();

  // 처음 모달 진입시 클릭한 index를 찾아서 보여줌
  useEffect(() => {
    if (query.shortsDiaryId !== diary.id) return;

    const PhotoId = getDiaryPhotoId(diary.id, index);

    const element = document.getElementById(PhotoId);

    delay(() => element?.scrollIntoView(), 100);
  }, []);

  return (
    <div
      id={getDiaryPhotoId(diary.id, index)}
      key={photo}
      className="flex-center relative h-[100dvh] w-full shrink-0 snap-start snap-always overflow-hidden"
    >
      {imageLoading && <LoadingPage />}
      <UImage
        src={photo}
        alt={diary.content}
        onLoad={() => setImageLoading(false)}
        className={`w-full shrink-0 object-contain`}
        width={400}
        height={400}
      />
    </div>
  );
};

export default _DiaryShortsPhoto;
